<template>
	<div class="wrapper is-danger p-3 is-radius-4 ">
		<div class="is-flex is-justify-content-space-between is-align-items-center mb-3">
			<span class="chip has-background-danger py-1 px-2  is-radius-5 is-size-7">Quiz Failed</span>
			<span class="has-text-danger">{{ attemptsCount }} of {{ quizMaxAttempts }} attempts used</span>
		</div>
		<div class="bold-text mb-2">
			{{ quizName }} Failed
		</div>
		<div class="mb-3">You scored {{ currentQuizScore }}% with {{ correctAnswersCount }} of {{ questionsPerQuiz }} questions answered correctly (or partially).</div>

		<div>
			<button class="button is-danger is-outlined is-fullwidth" @click="openReview">Review Your Answers</button>
		</div>
	</div>
	
</template>

<script lang="ts">
import { QuizGetters } from '@/store/modules/quiz/getters'
import { STATE_MODULES } from '@/store/state-modules'
import { OpenReviewModalMixin } from '@/utils/skill-assessment-mixins'
import { defineComponent } from 'vue'
import { mapGetters } from 'vuex'

export default defineComponent({
	mixins: [OpenReviewModalMixin],
	computed: {
		...mapGetters(STATE_MODULES.QUIZ, {
			quizName: QuizGetters.GET_QUIZ_NAME,
			questionsPerQuiz: QuizGetters.GET_QUESTIONS_COUNT,
			correctAnswersCount: QuizGetters.GET_CORRECT_ANSWERS_COUNT,
			currentQuizScore: QuizGetters.GET_CURRENT_QUIZ_SCORE,
			quizMaxAttempts: QuizGetters.GET_MAX_ATTEMPTS,
			attemptsCount: QuizGetters.GET_QUIZ_ATTEMPTS_COUNT
		})
	}
})
</script>

<style scoped>
	.wrapper{
		border: 1px solid rgba(239, 79, 93, 1);
		background: rgba(239, 79, 93, 0.09);
	}

	.chip {
		display: inline-block;
		color: #fff;
	}
</style>
